//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      money: '',
    }
  },
  mounted() {

  },
  computed: {

  },
  methods: {

  }

}



// WEBPACK FOOTER //
// ./src/components/user/certification.vue